import separateMenu from './separateMenu';
// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [separateMenu]
};

export default menuItems;
